<template lang="pug">
    div(:class="'context-'+context")
        include WhatWeDo.pug
</template>

<script>
import _ from "underscore"
import { mapState } from 'vuex'
import Api from "@/components/services/Api"

export default {
  name: 'WhatWeDo',
  computed: mapState([
    "context",
  ]),
  data () {
    return {
      // entries: [],
    }
  },
  created() {
    // const _this = this;
    // const token = this.$store.state.token;

    // this.$wagtail.getEntries("noticias", true).then(response => {
    //   let data = response.data
    //   _this.entries = data.results.slice(0, 3)
    // })
  }
}
</script>

<style scoped lang="scss">
@import "./../../variables";
@import "./../../variables_colreps";
@import "./../../variables_mexreps";

@import "WhatWeDo";

.context-colreps {
  @import 'WhatWeDoColreps';
}

.context-mexreps {
  @import 'WhatWeDoMexreps';
}

</style>




// WEBPACK FOOTER //
// src/components/whatwedo/WhatWeDo.vue